<template>
  <div class="camera-modal">
    <div class="camera-modal-content">
      <button class="close-button" @click="closeCameraModal">
        <i class="fa fa-times close-icon"></i>
      </button>
      <div class="camera-modal-header">
        <span>{{ title }}</span>
        <p>{{ description }}</p>
      </div>

      <img class="col-12" id="avatar-hora" src="~assets/permitirCamera.png" />

      <button class="col-12 camera-modal-button" @click="requestCameraPermission">
        {{ buttonText }}
        <i class="fa fa-arrow-right"></i>
      </button>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    title: String,
    description: String,
    buttonText: String
  },
}
</script>
